/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Shop_Channel_WebInputs */

const vi_order_shop_channel_web = /** @type {(inputs: Order_Shop_Channel_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website`)
};

/**

* @param {Order_Shop_Channel_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_shop_channel_web = /** @type {((inputs?: Order_Shop_Channel_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Shop_Channel_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_shop_channel_web(inputs)
});